/* Redux */
import { useSelector, useDispatch } from 'src/redux/hooks'

/* Types */
import { tProductPreview } from 'src/shared/frontendTypes/product'

const Redux = () => {

  /* ------------------------------------------------------ */
  const items = useSelector(store => store.Wunschliste.items)

  const dispatch = useDispatch()

  const deleteItem = (key: string) => 
    dispatch({ type: 'removeWunschlisteItem', payload: key })

  /* ------------------------------------------------------ */
  const products = useSelector(store => store.Wunschliste.products)

  const dispatchProducts = (products: tProductPreview[]) =>
    dispatch({ type: 'updateWunschlisteProducts', payload: products })

  /* ------------------------------------------------------ */

  return { 
    items, deleteItem,
    products, dispatchProducts
  }
  
}

export default Redux
